import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cie-order-process',
  template: `
    <p>
      order-process works!
    </p>
  `,
  styles: []
})
export class OrderProcessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
